<div class="min-h-full" style="background-color: #fafaf7;">

  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="flex flex-col items-center gap-5">
        <div class="relative w-12 h-12">
          <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
          <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
        </div>
        <p class="text-stone-600 font-medium text-sm">Chargement…</p>
      </div>
    </div>
  }

  @if (!isLoading()) {
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

      @if (errorMessage()) {
        <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
          <span class="material-icons text-base text-red-500">error_outline</span>
          {{ errorMessage() }}
        </div>
      }

      <div class="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden">

        <div class="px-4 sm:px-6 py-4 border-b border-stone-100 flex items-center gap-3 sm:gap-4 flex-wrap">
          <div class="relative flex-1 min-w-0 max-w-sm">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
            <input
              type="search"
              class="w-full bg-white border border-stone-200 text-stone-800 placeholder-stone-400 text-sm rounded-lg pl-11 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              placeholder="Rechercher un article de presse…"
              (input)="onSearch($any($event.target).value)"
            />
            @if (isFiltering()) {
              <div class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4">
                <div class="w-4 h-4 rounded-full border-2 border-stone-200 border-t-primary-400 animate-spin"></div>
              </div>
            }
          </div>
          <div class="relative flex-shrink-0">
            <select
              class="appearance-none bg-white border border-stone-200 text-stone-700 text-sm rounded-lg pl-3 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all cursor-pointer"
              (change)="onStatusFilter($any($event.target).value)"
            >
              <option value="">Tous les statuts</option>
              <option value="ACTI">En ligne</option>
              <option value="INAC">Hors ligne</option>
            </select>
            <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </div>
          <button (click)="onAddNew()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 ml-auto">
            <span class="material-icons text-base">add</span>
            Nouvel article
          </button>
        </div>

        <div class="overflow-x-auto">
          <table class="w-full text-sm">
            <thead>
              <tr class="border-b border-stone-100 bg-stone-50">
                <th class="px-3 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[48px]">ID</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Titre</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-32">Tags</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-36">Source</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-28">Date</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-20">Lien</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-28">Statut</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-stone-50">

              @if (revues().length === 0) {
                <tr>
                  <td colspan="6" class="px-6 py-16 text-center">
                    <div class="flex flex-col items-center gap-3">
                      <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center">
                        <svg class="w-6 h-6 text-stone-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25" />
                        </svg>
                      </div>
                      <p class="text-stone-500 text-sm font-medium">Aucune revue de presse trouvée</p>
                    </div>
                  </td>
                </tr>
              }

              @for (revue of revues(); track revue.id_press_article) {
                <tr class="hover:bg-stone-50 transition-colors duration-150 cursor-pointer"
                  (click)="onView(revue.id_press_article)">
                  <!-- ID -->
                  <td class="px-3 py-3 w-[48px]">
                    <span class="text-xs font-mono text-stone-400">#{{ revue.id_press_article }}</span>
                  </td>
                  <!-- Titre -->
                  <td class="px-4 py-3">
                    <p dir="ltr" class="font-semibold text-stone-800 text-xs truncate">{{ revue.title_ln1 }}</p>
                  </td>
                  <!-- Tags -->
                  <td class="px-4 py-3 w-32">
                    <app-tag-chips [value]="revue.press_tags" [max]="2"></app-tag-chips>
                    @if (!revue.press_tags) {
                      <span class="text-xs text-stone-300">—</span>
                    }
                  </td>
                  <!-- Source -->
                  <td class="px-4 py-3 w-36">
                    <span autoDir class="text-xs text-stone-500 truncate block">{{ revue.source_ln1 || '—' }}</span>
                  </td>
                  <!-- Date -->
                  <td class="px-4 py-3 w-28 whitespace-nowrap">
                    <span class="text-xs text-stone-500 font-mono">
                      {{ revue.publish_date ? (revue.publish_date | date:'dd/MM/yyyy') : '—' }}
                    </span>
                  </td>
                  <!-- Lien -->
                  <td class="px-4 py-3 w-20">
                    @if (revue.article_url) {
                      <a
                        [href]="revue.article_url"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="inline-flex items-center gap-1 text-xs text-primary-600 hover:text-primary-800 font-medium transition-colors"
                        title="Lire l'article"
                      >
                        <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                        </svg>
                        Lire
                      </a>
                    } @else {
                      <span class="text-stone-300 text-xs">—</span>
                    }
                  </td>
                  <!-- Statut -->
                  <td class="px-4 py-3 w-28">
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border whitespace-nowrap"
                      [class]="statusBadgeClass(revue.status || 'ACTI')">
                      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                        [class]="(revue.status || 'ACTI') === 'ACTI' ? 'bg-emerald-500' : (revue.status || 'ACTI') === 'ARCH' ? 'bg-stone-400' : 'bg-amber-400'"></span>
                      {{ revue.status_label || statusLabel(revue.status || 'ACTI') }}
                    </span>
                  </td>
                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>

      @if (pagination().totalPages > 1) {
        <div class="flex items-center justify-between">
          <p class="text-xs text-stone-400">
            Page <span class="font-semibold text-stone-600">{{ pagination().page }}</span> sur
            <span class="font-semibold text-stone-600">{{ pagination().totalPages }}</span>
          </p>
          <div class="flex items-center gap-1">
            <button type="button"
              (click)="onPageChange(pagination().page - 1)"
              [disabled]="pagination().page === 1"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </button>
            @for (p of pageNumbers(); track p) {
              @if (p === '...') {
                <span class="w-8 h-8 flex items-center justify-center text-xs text-stone-400">…</span>
              } @else {
                <button type="button"
                  (click)="onPageChange($any(p))"
                  class="w-8 h-8 rounded-xl text-xs font-medium transition-colors"
                  [class]="$any(p) === pagination().page ? 'bg-primary-600 text-white shadow-sm' : 'text-stone-500 hover:bg-stone-100'">
                  {{ p }}
                </button>
              }
            }
            <button type="button"
              (click)="onPageChange(pagination().page + 1)"
              [disabled]="pagination().page === pagination().totalPages"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>
          </div>
        </div>
      }

    </div>
  }
</div>

